import FfnManagementPopupController from './ffn-management-popup-controller';
import ffnManagementRemoveConfirmation from './ffn-management-remove-confirmation.html';

export default function FfnManagementService(
    modalService,
    staticDataGetter,
) {
    'ngInject';

    Object.assign(this, {
        getAirlines,
        removeConfirmation,
    });

    function getAirlines() {
        return staticDataGetter
            .getAirlines()
            .then((airlines) => airlines
                .map(({ShortName, Code}) => ({text: ShortName, value: Code}))
                .sort((item1, item2) => {
                    const text1 = item1 && item1.text.toLowerCase() || '';
                    const text2 = item2 && item2.text.toLowerCase() || '';
                    if (text1 > text2) {
                        return 1;
                    }
                    return -1;
                }));
    }

    function removeConfirmation(clubCard, selectedSeats) {
        const modalInstance = modalService.openModal({
            controller: FfnManagementPopupController,
            controllerAs: '$ctrl',
            template: ffnManagementRemoveConfirmation,
            size: 'sm',
            resolve: {
                clubCard: () => clubCard,
                selectedSeats: () => selectedSeats,
            },
        });
        return modalInstance.result;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/adult/ffn-management/ffn-management-service.js